//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

/**
 * These values are determined by Facebook and are not within our control. The tasks represent
 * the actions that a given Facebook user is able to perform on a given Facebook page. When attached
 * to an Instagram business account, the tasks represent the actions that a given Facebook user is able
 * to perform on the Facebook page linked to that Instagram business account.
 */
enum FacebookPageTask {
  Analyze = 'ANALYZE',
  Advertise = 'ADVERTISE',
  Moderate = 'MODERATE',
  CreateContent = 'CREATE_CONTENT',
  Manage = 'MANAGE',
}

export default FacebookPageTask;
